
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34748',
  depVersions: {
  "documents-public-ui": "static-1.34748",
  "atom": "static-1.5172",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2595",
  "client-types": "static-1.479",
  "cssUtils": "static-1.819",
  "customer-data-filters-ui": "static-1.40117",
  "customer-data-objects": "static-1.7776",
  "customer-data-property-utils": "static-1.8194",
  "documents-lib": "static-1.34753",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.343",
  "FormsCommonComponents": "static-1.86111",
  "FormUrlGenerator": "static-2.4819",
  "foundations-theming-specialty": "static-1.2244",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5689",
  "hs-test-utils": "static-1.8116",
  "hub-http": "static-1.6319",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11879",
  "HubStyleTokens": "static-2.11572",
  "I18n": "static-7.1634",
  "icons": "static-2.651",
  "jasmine-immutable": "static-1.3119",
  "jasmine-runner": "static-1.6559",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7253",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5494",
  "quartz": "static-1.7149",
  "react": "static-7.187",
  "react-dlb": "static-1.80",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16780",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5413",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8272",
  "reference-resolvers-lite": "static-1.8195",
  "reporting-data": "static-1.67932",
  "reporting-reports": "static-1.67610",
  "reporting-snowflake": "static-1.56550",
  "reporting-testing-lib": "static-1.9865",
  "reporting-visualizations": "static-1.60008",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9043",
  "sanitize": "static-1.4575",
  "sanitize-text": "static-1.8243",
  "self-service-api": "static-1.10346",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1843",
  "signup-constants": "static-1.19062",
  "signup-ui-url-generator": "static-2.8155",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4858",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4859",
  "ui-addon-form-validation": "static-1.11087",
  "ui-asset-management-lib": "static-1.11158",
  "ui-images": "static-2.1176",
  "UIComponents": "static-3.8518",
  "usage-tracker": "static-1.7446",
  "usage-tracker-container": "static-1.7436",
  "usage-tracker-core": "static-1.7296",
  "viral-links-lib": "static-1.7166",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9760",
  "foundations-components": "static-1.8119",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.927",
  "quartz-core": "static-1.6368",
  "quick-fetch": "static-1.3988",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4754",
  "ui-addon-i18n": "static-1.11248",
  "ui-addon-upgrades": "static-9.18132",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3470",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3426",
  "quartz-webpack": "static-1.3373",
  "foundations-assets": "static-1.4967",
  "foundations-theming": "static-1.4528",
  "hub-http-shared-msw-handlers": "static-1.10198",
  "hubspotter-http": "static-1.4722",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7347",
  "crm-message-bus": "static-1.43229",
  "customer-data-filters-ui-msw-helpers": "static-1.22552",
  "customer-data-objects-ui-components": "static-1.13128",
  "customer-data-reference-ui-components": "static-1.13268",
  "customer-data-ui-utilities": "static-1.9923",
  "events-data-lib": "static-1.328",
  "framework-builder-read-service-client": "static-1.4076",
  "framework-data-schema-quick-fetch": "static-1.6893",
  "framework-data-schema-resolvers": "static-1.6988",
  "inbound-db-meta-service-client": "static-1.3657",
  "inbound-db-properties-service-client": "static-1.3916",
  "multi-account-reference-resolvers": "static-1.1080",
  "onboarding-tours": "static-1.16779",
  "reporting-datasets-permissions-lib": "static-1.13953",
  "ui-addon-teams": "static-1.21678",
  "quartz-auth": "static-1.824",
  "ui-business-units-lib": "static-1.9160",
  "usage-tracker-session-replay": "static-1.5132",
  "ai-components-ui-library": "static-1.9195",
  "ContentUtils": "static-1.68635",
  "customer-data-properties": "static-1.51906",
  "forms-ai-lib": "static-1.4468",
  "forms-utils-lib": "static-1.12762",
  "foundations-components-test-utils": "static-1.5602",
  "react-dnd-compat": "static-1.4712",
  "react-tinymce": "static-1.55498",
  "tinymce-config": "static-2.54624",
  "ui-gdpr-components": "static-1.10448",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3513",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3227",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.152",
  "ui-fonts": "static-1.834",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4424",
  "csstype": "static-1.50",
  "quartz-head": "static-1.814",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1640",
  "external-options-client-types": "static-1.4201",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.824",
  "frontend-preferences-client": "static-1.8023",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3797",
  "reporting-client-types": "static-1.2564",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25661",
  "hubspot-apollo-client": "static-1.4976",
  "foundations-components-legacy": "static-1.1144",
  "merchandise-lib": "static-1.265",
  "quartz-routing": "static-1.579",
  "hs-story-utils": "static-1.9520",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.322",
  "timezone-utils": "static-2.5341",
  "seat-types-lib": "static-1.238",
  "react-create-root-preference": "static-1.32",
  "bend-plugin-foundations-components": "static-1.4388",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2168",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.26",
  "quartz-test": "static-1.824",
  "quartz-tracking": "static-1.528",
  "trellis-components": "static-1.2187",
  "bend-plugin-chirp-manifest": "static-1.164",
  "chirp-fetch": "static-1.1985",
  "purchase-motions-components": "static-1.6065",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4151",
  "bender-build-tools": "static-1.3281",
  "bend-plugin-foundations-theming": "static-1.3011",
  "stylex": "static-1.34",
  "restore-request-side-panel-lib": "static-1.1119",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.273",
  "pulse": "static-1.693",
  "conditional-properties-service-client": "static-1.3868",
  "crm-pipelines-api-client-types": "static-1.4209",
  "fdsr-migration-layer": "static-1.107",
  "multi-currency-client-types": "static-1.3761",
  "getting-started-shared-tasks": "static-1.18679",
  "growth-data-modal": "static-1.5580",
  "growth-onboarding-confetti": "static-1.3164",
  "growth-onboarding-next-action-utils": "static-1.2200",
  "navigation-components": "static-1.18253",
  "onboarding-tours-client": "static-1.4993",
  "onboarding-tours-utils": "static-1.845",
  "ui-shepherd-react": "static-3.10320",
  "ui-shepherd-tracker": "static-1.7701",
  "ui-universal-auth": "static-1.9092",
  "user-context": "static-1.5208",
  "hubspotter-http-shared-msw-handlers": "static-1.10196",
  "magpie-lib": "static-1.5614",
  "navigation-messaging": "static-1.7580",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21754",
  "copilot-toolkit": "static-1.11380",
  "cms-field-types": "static-1.4911",
  "content-icons-ui": "static-1.2253",
  "integrations-lib": "static-1.16467",
  "calling-global-api": "static-1.64842",
  "calling-internal-common": "static-1.31408",
  "calling-lifecycle-internal": "static-1.66224",
  "calling-lifecycle-messages": "static-1.58518",
  "commerce-products-lib": "static-1.9896",
  "crm-links": "static-1.6404",
  "customer-data-properties-shared-msw-handlers": "static-1.9525",
  "file-manager-components": "static-1.23872",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4291",
  "meetings-icalendar-utils-lib": "static-1.732",
  "object-builder-ui-client": "static-1.49076",
  "pipeline-validation-client-types": "static-1.4037",
  "property-value-citations": "static-1.2520",
  "smart-property-lib": "static-1.7682",
  "tiered-pricing": "static-1.1443",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9162",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19995",
  "tinymce-themes": "static-1.56594",
  "data-token-picker": "static-1.16574",
  "hub-http-contrib": "static-1.3140",
  "interframe": "static-3.4858",
  "tinymce-data": "static-1.40709",
  "tinymce-plugins": "static-1.57738",
  "ui-addon-sales-email": "static-1.5308",
  "onboarding-scopes": "static-1.6560",
  "ui-addon-opt": "static-4.8458",
  "apollo-link-hub-http": "static-2.4751",
  "hubspot-apollo-cache": "static-1.435",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.270",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1038",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6068",
  "event-emitter": "static-1.1047",
  "bend-plugin-pulse": "static-1.196",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2124",
  "growth-onboarding-next-action-components": "static-1.2228",
  "user-context-client": "static-1.4680",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5074",
  "nest": "static-1.330",
  "reactive-lib": "static-1.824",
  "simple-logging-lib": "static-1.3148",
  "unified-auth-core-lib": "static-1.888",
  "getting-started-shared-tasks-store": "static-1.17797",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1031",
  "integrations-error-boundary-lib": "static-1.13882",
  "integrations-tracking-lib": "static-1.5704",
  "native-integrations-shared-strings": "static-1.7881",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10460",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.606",
  "calling-error-reporting": "static-1.31415",
  "shared-worker-versioning": "static-1.11133",
  "calling-usage-tracker": "static-1.6641",
  "voice-sms-access-library": "static-1.1379",
  "customer-data-tracking": "static-1.6988",
  "commerce-permissions": "static-1.875",
  "products-iframe-lib": "static-1.8198",
  "products-ui-components-shared-msw-handlers": "static-1.10580",
  "location-customization-utils-lib": "static-1.9538",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4252",
  "video-components-external": "static-1.11585",
  "video-data-lib": "static-1.35243",
  "data-agent-kit": "static-1.350",
  "feedback-loader": "static-1.29473",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10281",
  "fsm": "static-1.3827",
  "policy-lib": "static-1.6878",
  "react-colorpicker": "static-2.10305",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10344",
  "FileManagerLib": "static-1.39512",
  "NamespacedHubStyle": "static-2.9128",
  "FileManagerCore": "static-1.39371",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7904",
  "layout-dnd-components": "static-1.12627",
  "layout-dnd-utils": "static-1.11602",
  "react-codemirror": "static-1.10726",
  "ui-addon-emoji-picker": "static-1.9985",
  "ui-brand-identity-lib": "static-1.15618",
  "InboxConnectUtils": "static-4.15064",
  "meetings-connect-utils-lib": "static-1.7702",
  "breeze-engine-core": "static-1.309",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3115",
  "ads-unified-auth-lib": "static-1.306",
  "google-sheets-integration-lib": "static-1.520",
  "microsoft-drive-integration-lib": "static-1.656",
  "slack-ui-library": "static-1.10492",
  "calling-orchestration-schema": "static-1.36156",
  "sales-views-client-types": "static-1.4354",
  "crm-record-cards-service-types": "static-1.3660",
  "content-media-composition-data-lib": "static-1.12610",
  "content-media-compositions": "static-2.16617",
  "media-bridge-lib": "static-1.19090",
  "trellis-story-utils": "static-1.4611",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6062",
  "FileManagerImages": "static-1.37023",
  "video-components": "static-1.13587",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4635",
  "video-embed": "static-1.36077",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8801",
  "ui-coaching-tips": "static-1.28828",
  "ContentData": "static-1.68710",
  "layout-data-lib": "static-1.9927",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22307",
  "outpost": "static-1.4269",
  "growth-onboarding-feedback-components": "static-1.6677",
  "advanced-menus-core": "static-1.15282",
  "advanced-menus-lib": "static-1.12197",
  "ExportDialog": "static-6.10479",
  "ui-memberships-settings-lib": "static-1.34303",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15281",
  "simple-menus-lib": "static-1.16798"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34748",
  "atom": "/atom/static-1.5172",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2595",
  "client-types": "/client-types/static-1.479",
  "cssUtils": "/cssUtils/static-1.819",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40117",
  "customer-data-objects": "/customer-data-objects/static-1.7776",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8194",
  "documents-lib": "/documents-lib/static-1.34753",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.343",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4819",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2244",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5689",
  "hs-test-utils": "/hs-test-utils/static-1.8116",
  "hub-http": "/hub-http/static-1.6319",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11879",
  "HubStyleTokens": "/HubStyleTokens/static-2.11572",
  "I18n": "/I18n/static-7.1634",
  "icons": "/icons/static-2.651",
  "jasmine-immutable": "/jasmine-immutable/static-1.3119",
  "jasmine-runner": "/jasmine-runner/static-1.6559",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7253",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5494",
  "quartz": "/quartz/static-1.7149",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16780",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5413",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8272",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8195",
  "reporting-data": "/reporting-data/static-1.67932",
  "reporting-reports": "/reporting-reports/static-1.67610",
  "reporting-snowflake": "/reporting-snowflake/static-1.56550",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9865",
  "reporting-visualizations": "/reporting-visualizations/static-1.60008",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9043",
  "sanitize": "/sanitize/static-1.4575",
  "sanitize-text": "/sanitize-text/static-1.8243",
  "self-service-api": "/self-service-api/static-1.10346",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1843",
  "signup-constants": "/signup-constants/static-1.19062",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8155",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4858",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4859",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11087",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11158",
  "ui-images": "/ui-images/static-2.1176",
  "UIComponents": "/UIComponents/static-3.8518",
  "usage-tracker": "/usage-tracker/static-1.7446",
  "usage-tracker-container": "/usage-tracker-container/static-1.7436",
  "usage-tracker-core": "/usage-tracker-core/static-1.7296",
  "viral-links-lib": "/viral-links-lib/static-1.7166",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9760",
  "foundations-components": "/foundations-components/static-1.8119",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.927",
  "quartz-core": "/quartz-core/static-1.6368",
  "quick-fetch": "/quick-fetch/static-1.3988",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4754",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11248",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18132",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3470",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3426",
  "quartz-webpack": "/quartz-webpack/static-1.3373",
  "foundations-assets": "/foundations-assets/static-1.4967",
  "foundations-theming": "/foundations-theming/static-1.4528",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10198",
  "hubspotter-http": "/hubspotter-http/static-1.4722",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7347",
  "crm-message-bus": "/crm-message-bus/static-1.43229",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22552",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13128",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13268",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9923",
  "events-data-lib": "/events-data-lib/static-1.328",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4076",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6893",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6988",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3657",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3916",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1080",
  "onboarding-tours": "/onboarding-tours/static-1.16779",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13953",
  "ui-addon-teams": "/ui-addon-teams/static-1.21678",
  "quartz-auth": "/quartz-auth/static-1.824",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9160",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5132",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9195",
  "ContentUtils": "/ContentUtils/static-1.68635",
  "customer-data-properties": "/customer-data-properties/static-1.51906",
  "forms-ai-lib": "/forms-ai-lib/static-1.4468",
  "forms-utils-lib": "/forms-utils-lib/static-1.12762",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5602",
  "react-dnd-compat": "/react-dnd-compat/static-1.4712",
  "react-tinymce": "/react-tinymce/static-1.55498",
  "tinymce-config": "/tinymce-config/static-2.54624",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10448",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3513",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3227",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.152",
  "ui-fonts": "/ui-fonts/static-1.834",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4424",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.814",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1640",
  "external-options-client-types": "/external-options-client-types/static-1.4201",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.824",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8023",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3797",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25661",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4976",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1144",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "quartz-routing": "/quartz-routing/static-1.579",
  "hs-story-utils": "/hs-story-utils/static-1.9520",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.322",
  "timezone-utils": "/timezone-utils/static-2.5341",
  "seat-types-lib": "/seat-types-lib/static-1.238",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4388",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2168",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.26",
  "quartz-test": "/quartz-test/static-1.824",
  "quartz-tracking": "/quartz-tracking/static-1.528",
  "trellis-components": "/trellis-components/static-1.2187",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.164",
  "chirp-fetch": "/chirp-fetch/static-1.1985",
  "purchase-motions-components": "/purchase-motions-components/static-1.6065",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4151",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3011",
  "stylex": "/stylex/static-1.34",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1119",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.273",
  "pulse": "/pulse/static-1.693",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3868",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4209",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.107",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3761",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18679",
  "growth-data-modal": "/growth-data-modal/static-1.5580",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3164",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2200",
  "navigation-components": "/navigation-components/static-1.18253",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4993",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.845",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10320",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7701",
  "ui-universal-auth": "/ui-universal-auth/static-1.9092",
  "user-context": "/user-context/static-1.5208",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10196",
  "magpie-lib": "/magpie-lib/static-1.5614",
  "navigation-messaging": "/navigation-messaging/static-1.7580",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21754",
  "copilot-toolkit": "/copilot-toolkit/static-1.11380",
  "cms-field-types": "/cms-field-types/static-1.4911",
  "content-icons-ui": "/content-icons-ui/static-1.2253",
  "integrations-lib": "/integrations-lib/static-1.16467",
  "calling-global-api": "/calling-global-api/static-1.64842",
  "calling-internal-common": "/calling-internal-common/static-1.31408",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66224",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58518",
  "commerce-products-lib": "/commerce-products-lib/static-1.9896",
  "crm-links": "/crm-links/static-1.6404",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9525",
  "file-manager-components": "/file-manager-components/static-1.23872",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4291",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.732",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49076",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4037",
  "property-value-citations": "/property-value-citations/static-1.2520",
  "smart-property-lib": "/smart-property-lib/static-1.7682",
  "tiered-pricing": "/tiered-pricing/static-1.1443",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9162",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19995",
  "tinymce-themes": "/tinymce-themes/static-1.56594",
  "data-token-picker": "/data-token-picker/static-1.16574",
  "hub-http-contrib": "/hub-http-contrib/static-1.3140",
  "interframe": "/interframe/static-3.4858",
  "tinymce-data": "/tinymce-data/static-1.40709",
  "tinymce-plugins": "/tinymce-plugins/static-1.57738",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5308",
  "onboarding-scopes": "/onboarding-scopes/static-1.6560",
  "ui-addon-opt": "/ui-addon-opt/static-4.8458",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4751",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.435",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.270",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1038",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6068",
  "event-emitter": "/event-emitter/static-1.1047",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.196",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2124",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2228",
  "user-context-client": "/user-context-client/static-1.4680",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5074",
  "nest": "/nest/static-1.330",
  "reactive-lib": "/reactive-lib/static-1.824",
  "simple-logging-lib": "/simple-logging-lib/static-1.3148",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.888",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17797",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1031",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13882",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5704",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7881",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10460",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.606",
  "calling-error-reporting": "/calling-error-reporting/static-1.31415",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11133",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6641",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1379",
  "customer-data-tracking": "/customer-data-tracking/static-1.6988",
  "commerce-permissions": "/commerce-permissions/static-1.875",
  "products-iframe-lib": "/products-iframe-lib/static-1.8198",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10580",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9538",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4252",
  "video-components-external": "/video-components-external/static-1.11585",
  "video-data-lib": "/video-data-lib/static-1.35243",
  "data-agent-kit": "/data-agent-kit/static-1.350",
  "feedback-loader": "/feedback-loader/static-1.29473",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10281",
  "fsm": "/fsm/static-1.3827",
  "policy-lib": "/policy-lib/static-1.6878",
  "react-colorpicker": "/react-colorpicker/static-2.10305",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10344",
  "FileManagerLib": "/FileManagerLib/static-1.39512",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9128",
  "FileManagerCore": "/FileManagerCore/static-1.39371",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7904",
  "layout-dnd-components": "/layout-dnd-components/static-1.12627",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11602",
  "react-codemirror": "/react-codemirror/static-1.10726",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9985",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15618",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15064",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7702",
  "breeze-engine-core": "/breeze-engine-core/static-1.309",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3115",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.306",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.520",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.656",
  "slack-ui-library": "/slack-ui-library/static-1.10492",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36156",
  "sales-views-client-types": "/sales-views-client-types/static-1.4354",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3660",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12610",
  "content-media-compositions": "/content-media-compositions/static-2.16617",
  "media-bridge-lib": "/media-bridge-lib/static-1.19090",
  "trellis-story-utils": "/trellis-story-utils/static-1.4611",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6062",
  "FileManagerImages": "/FileManagerImages/static-1.37023",
  "video-components": "/video-components/static-1.13587",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4635",
  "video-embed": "/video-embed/static-1.36077",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8801",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28828",
  "ContentData": "/ContentData/static-1.68710",
  "layout-data-lib": "/layout-data-lib/static-1.9927",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22307",
  "outpost": "/outpost/static-1.4269",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6677",
  "advanced-menus-core": "/advanced-menus-core/static-1.15282",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12197",
  "ExportDialog": "/ExportDialog/static-6.10479",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34303",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15281",
  "simple-menus-lib": "/simple-menus-lib/static-1.16798"
}
};
